import { BatchSplitDialog } from "../containers/BatchSplitDialog";
import { CommonTab } from "../containers/CommonTab";
import { RegenerateTemplate } from "./RegenerateTemplate";

export const TemplateDialogContent = ({
  templates,
  setTemplates,
  handleBatchSplitUpdate,
  selectedIndex,
  setSelectedIndex,
  setEditedMap,
  setFocusedField,
  editedMap,
  focusedField,
  updateBatchSplit,
  handleAddBatch,
  handleDeleteBatch,
  handleDeleteBatchDialog,
  handleOptionChangeRecipeBatch,
  handleOptionChangeRecipe,
  globalData,
  handleCustomTableChange,
  categorylistQuery,
  handleRecipes,
  onChangeFilter,
  updateTableData,
  onSearchChange,
  searchHandler,
  handleCustomFieldChange,
  recipelistQuery,
  states,
}) => {
  if (templates.isShowErrorMessage) {
    return (
      <BatchSplitDialog
        templates={templates}
        setTemplates={setTemplates}
        handleBatchSplitUpdate={handleBatchSplitUpdate}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        setEditedMap={setEditedMap}
        setFocusedField={setFocusedField}
        editedMap={editedMap}
        focusedField={focusedField}
        updateBatchSplit={updateBatchSplit}
        handleAddBatch={handleAddBatch}
        handleDeleteBatch={handleDeleteBatch}
        handleDeleteBatchDialog={handleDeleteBatchDialog}
        globalData={globalData}
      />
    );
  }

  if (templates.isCreateDialog) {
    return (
      <CommonTab
        state={states.templateDetails}
        templates={templates}
        handleOptionChangeRecipeBatch={handleOptionChangeRecipeBatch}
        handleOptionChangeRecipe={handleOptionChangeRecipe}
        globalData={globalData}
        setTemplates={setTemplates}
      />
    );
  } else {
    return (
      <RegenerateTemplate
        handleCustomTableChange={handleCustomTableChange}
        templates={templates}
        categorylistQuery={categorylistQuery}
        handleRecipes={handleRecipes}
        onChangeFilter={onChangeFilter}
        updateTableData={updateTableData}
        onSearchChange={onSearchChange}
        searchHandler={searchHandler}
        handleCustomFieldChange={handleCustomFieldChange}
        recipelistQuery={recipelistQuery}
      />
    );
  }
};
